import React from 'react';
import './Setting.scss';
import { SettingOptions, SettingsHeader } from './Settings';
import { REACT_APP_GOOGLE_TRANSLATE_API_KEY } from '../../../processENV';
import SDK from '../../../SDK';
import { translateLanguage } from '../../../Redux/feature/translateLanguageDataSlice';
import { store } from '../../../Redux/store';
import { useSelector } from 'react-redux';
import { getTranslateTargetLanguage, setLocalWebsettings } from '../../../Helpers/Utility';
import Chat from './Chat';
import BlockedContacts from './BlockedContacts';

let optionsArray = [
    { label: 'Chat', image: 'chat' },
    // { label: 'Archived Settings', image: 'Archived' },
    // { label: 'Notifications', image: 'notification' },
    // { label: 'Starred', image: 'star' },
    { label: 'Blocked', image: 'blocked' },
    // { label: 'About and Help', image: 'about' },
    // { label: 'Delete My Account', image: 'delete' }
];

const Setting = (props = {}) => {
    const [parrentView, setParrentView] = React.useState(true)
    const [activeTab, setActiveTab] = React.useState(null)
    // const [language,setLanguage] = React.useState("English")
    const { handleBackFromSetting, featureStateData = {} } = props
    const { translateLanguages = [] } = useSelector((state) => state.translateLanguage)

    const handleSettings = (label = "") => {
        setParrentView(false)
        setActiveTab(label)
    }

    const getLanguages = async () => {
        try {
            const result = await SDK.getTranslateLanguages(REACT_APP_GOOGLE_TRANSLATE_API_KEY);
            const { data: { languages = [] } = {}, statusCode = 0 } = result || {};
            if (statusCode === 200) {
                store.dispatch(translateLanguage(languages));
            }
        } catch (error) { }
    };

    const setSelectedLaun = () => {
        const langIndex = translateLanguages?.findIndex(i => i.language === getTranslateTargetLanguage());
        const langSelected = translateLanguages[langIndex]?.name;
        return langSelected;
    }

    const handleBackToSetting = (e) => {
        setParrentView(true);
    }

    React.useEffect(() => {
        getLanguages();
    }, [])

    React.useEffect(() => {
        setSelectedLaun();
        getTranslateTargetLanguage() === "" && setLocalWebsettings("translateLang", "en");
    }, [translateLanguages])

    return (
        <React.Fragment>
            {parrentView &&
                <div className="setting-container">
                    <div>
                        <div className="settinglist">
                            <SettingsHeader
                                handleBackFromSetting={handleBackFromSetting}
                                label={'Settings'}
                            />
                            <ul className="setting-list-ul">
                                {
                                    optionsArray.map(options => {
                                        const { label, image } = options
                                        return <SettingOptions
                                            key={image}
                                            handleOptions={handleSettings}
                                            label={label}
                                            image={image}
                                        />
                                    })
                                }
                                {/* <SettingOptions handleOptions={this.props.logoutStatus} label={'Logout'} image={'logout'} /> */}
                            </ul>
                        </div>
                    </div>
                </div>
            }
            {!parrentView &&
                <React.Fragment>
                    {/** {activeTab === 'Archived' && <Archive handleBackToSetting={this.handleBackToSetting} />} */}
                    {activeTab === 'chat' &&
                        <Chat
                            setSelectedLaun={(setSelectedLaun() !== "") ? setSelectedLaun() : "English"}
                            handleBackToSetting={handleBackToSetting}
                            featureStateData={featureStateData}
                        />}
                    {activeTab === 'blocked' && <BlockedContacts handleBackToSetting={handleBackToSetting} />}
                    {/** {activeTab === 'notification' && <Notification handleBackToSetting={this.handleBackToSetting} />}
                    {activeTab === 'star' &&
                        <StarredMessages
                        handleBackToSetting={this.handleBackToSetting}
                        featureStateData={featureStateData}
                        />
                    }
                    {activeTab === 'blocked' && <Blocked handleBackToSetting={this.handleBackToSetting} />}
                    {activeTab === 'about' && <About handleBackToSetting={this.handleBackToSetting} />}
                    {activeTab === 'delete' && <DeleteMyAccount handleBackToSetting={this.handleBackToSetting} />} */}
                </React.Fragment>
            }
        </React.Fragment>
    );
}

export default Setting
